// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New List rows */
.esbRow {
    margin-bottom: 10px;
    box-shadow: 0px 3px 6px -1px rgba(0, 0, 0, 0.3);
}

/*

.esbRow.esbRowExpanded>.esbRowHead .esbDescription {
    white-space: pre-line;
    overflow: visible;
}
.esbRow>.esbRowHead .esbDescription {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
 */


.esbRowHead h2,
.esbRowHead h3,
.esbRowHead h4 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.esbRowExpanded .esbRowHead h2,
.esbRowExpanded .esbRowHead h3,
.esbRowExpanded .esbRowHead h4 {
    white-space: normal;
}

.esbRowExpanded .esbRowHead {
    max-height: none;
}

.esbRowHead {
    display: flex;
    min-height: 60px;
    max-height: 80px;
    overflow: hidden;
}

.esbRowHead.esbNotFocusable {
    overflow: initial;
}

.esbRowMain.esbFocusable {
    overflow: hidden;
}

.esbRowHead .esbRowMain {
    width: 100%;
}

.entryscape .entryListRow a.esbRowLink {
    color: inherit;
}

.entryscape .entryListRow a.esbRowLink:hover {
    text-decoration: inherit;
}

.esbRowHead.esbDefaultExpandButton .esbRowMain {
    width: calc(100% - 50px);
}

.esbRowHead .esbRowControl {
    width: 47px;
    margin-top: 3px;
    margin-right: 3px;
}

.esbRowHead .esbRowControl > button {
    border: 1px transparent;
    height: 32px;
    width: 34px;
    margin-top: 12px;
    margin-right: 12px;
}

.esbRowHead .esbRowControl > button:hover {
    background: white;
    color: #005a9c;
}

.esbRowHead .esbRowControl > button:focus {
    border: 1px solid #005a9c;
    color: #005a9c;
}

.esbRowExpand {
    background: #f7f7f7;
}

a.rdformsUrl {
    color: black;
}

.esbPadding .esbRowExpand,
.esbPadding .esbRowHead .esbRowMain {
    padding: 15px;
}

.esbRowExpand h4 {
    margin-top: 20px;
    margin-bottom: 0px;
}

.esbRowExpand .escoList .entryList.regular > div {
    background: white;
    border-top: 1px solid #f7f7f7;
}

.esbRowExpand .escoList .entryList.regular > div:first-child {
    border-top-width: 0px;
}

.esbRowHead > .label {
    margin-right: 10px;
}

.esbRowHead > .float-right.btn {
    margin-left: 10px;
}

.esbRowClickExpand > .esbRowHead {
    cursor: pointer;
}


.entryList .vmiddle.entryControls {
    vertical-align: top;
}

.entryList .entryRow .entryControls button {
    visibility: visible;
}

/* --- List block, common card classes --- */
.entryscape .cardList-body {
    max-width: 400px;
    box-shadow: 0px 1px 5px #555;
    background-color: white !important;
    position: relative;
    top: 0;
    transition: all .1s ease-in;
    margin: 10px;
    display: inline-block;
}

.entryscape .cardList-header {
    display: flex;
    /* flex-wrap: wrap; */
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

/* Clickable row - cardlist case */
.entryscape .cardList-body {
    border: 1px solid #e8e8e8;
}

.entryscape .cardList-body:hover,
.entryscape .cardList-body:focus {
    border: 1px solid darkgrey;
}

.entryscape .cardList-body.esbRowClickable:hover,
.entryscape .cardList-body.esbRowClickable:focus {
    border: 1px solid blue;
}

.entryscape .cardList-body.esbRowClickable > a {
    display: inline-block;
}

/* Clickable row - regular case */
.entryscape .esbRow.esbRowClickable .esbRowHead {
    border: 1px solid transparent;
}

.entryscape .esbRow.esbRowClickable .esbRowHead:hover {
    background: #f7f7f7;
    color: #005a9c;
}

.entryscape .esbRow.esbRowClickable .esbRowHead:focus {
    border: 1px solid #005a9c;
    color: #005a9c;
}

/* End clickable row */

.esb1Col .cardLayout > * > * > .entryList.regular {
    column-count: 1;
    column-gap: 10px;
    max-width: 1200px;
}

@media (min-width: 620px) {
    .esb1Col .cardLayout > * > * > .entryList.regular {
        column-count: 2;
    }
}

@media (min-width: 960px) {
    .esb1Col .cardLayout > * > * > .entryList.regular {
        column-count: 3;
    }
}

.esb2Col .cardLayout > * > * > .entryList.regular {
    column-count: 1;
    column-gap: 10px;
    max-width: 880px;
}

@media (min-width: 920px) {
    .esb2Col .cardLayout > * > * > .entryList.regular {
        column-count: 2;
    }
}

@media (min-width: 1260px) {
    .esb2Col .cardLayout > * > * > .entryList.regular {
        column-count: 3;
    }
}

/*  Specific css, needed? */
.entryscape .cardList-title {
    margin: 1em;
    font-size: 1.5rem;
    font-style: italic;
}

.entryscape .cardList-description {
    margin: 1em;
    margin-top: 0;
    padding: .5rem;
    line-height: 1.6em;
}

.entryscape .img-container {
    max-width: 400px;
}

.entryscape img {
    width: 100%;
    max-height: 100%;
}

.esbRow.esbRowExpanded > .esbRowHead .esbDescription {
    white-space: pre-line;
    overflow: visible;
}

.esbRow > .esbRowHead .esbDescription {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Pagination */
.entryscape .page-link:not(:disabled) {
    color: #005a9c;
}

.entryscape .pagination .page-text {
    min-width: 2.6em;
    margin-left: .5em;
    margin-right: .5em;
    border-radius: 4em;
}

/* Override siteVision css for pagination */
.entryscape .pagination a {
    margin: 0;
}

.entryscape .pagination span {
    margin-bottom: 0;
}

/* Row alignment */
.esbRowAlign {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.esbRowAlignPrimary {
    flex-grow: 1;
}

.esbRow.esbRowExpanded > .esbRowHead > .esbRowMain > .esbRowAlign > .esbRowEllipsis {
    white-space: normal;
    overflow: visible;
}

.esbRow > .esbRowHead .esbRowAlign > .esbRowEllipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.esbList__hidden {
    visibility: hidden;
}

.esbSpinner {
    visibility: visible;
    position: absolute;
    height: 260px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/list/list.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;;;;;;;;;;;EAWE;;;AAGF;;;IAGI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;IAClB,MAAM;IACN,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,iCAAiC;AACjC;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,sBAAsB;;AAEtB;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":["/* New List rows */\n.esbRow {\n    margin-bottom: 10px;\n    box-shadow: 0px 3px 6px -1px rgba(0, 0, 0, 0.3);\n}\n\n/*\n\n.esbRow.esbRowExpanded>.esbRowHead .esbDescription {\n    white-space: pre-line;\n    overflow: visible;\n}\n.esbRow>.esbRowHead .esbDescription {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n */\n\n\n.esbRowHead h2,\n.esbRowHead h3,\n.esbRowHead h4 {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.esbRowExpanded .esbRowHead h2,\n.esbRowExpanded .esbRowHead h3,\n.esbRowExpanded .esbRowHead h4 {\n    white-space: normal;\n}\n\n.esbRowExpanded .esbRowHead {\n    max-height: none;\n}\n\n.esbRowHead {\n    display: flex;\n    min-height: 60px;\n    max-height: 80px;\n    overflow: hidden;\n}\n\n.esbRowHead.esbNotFocusable {\n    overflow: initial;\n}\n\n.esbRowMain.esbFocusable {\n    overflow: hidden;\n}\n\n.esbRowHead .esbRowMain {\n    width: 100%;\n}\n\n.entryscape .entryListRow a.esbRowLink {\n    color: inherit;\n}\n\n.entryscape .entryListRow a.esbRowLink:hover {\n    text-decoration: inherit;\n}\n\n.esbRowHead.esbDefaultExpandButton .esbRowMain {\n    width: calc(100% - 50px);\n}\n\n.esbRowHead .esbRowControl {\n    width: 47px;\n    margin-top: 3px;\n    margin-right: 3px;\n}\n\n.esbRowHead .esbRowControl > button {\n    border: 1px transparent;\n    height: 32px;\n    width: 34px;\n    margin-top: 12px;\n    margin-right: 12px;\n}\n\n.esbRowHead .esbRowControl > button:hover {\n    background: white;\n    color: #005a9c;\n}\n\n.esbRowHead .esbRowControl > button:focus {\n    border: 1px solid #005a9c;\n    color: #005a9c;\n}\n\n.esbRowExpand {\n    background: #f7f7f7;\n}\n\na.rdformsUrl {\n    color: black;\n}\n\n.esbPadding .esbRowExpand,\n.esbPadding .esbRowHead .esbRowMain {\n    padding: 15px;\n}\n\n.esbRowExpand h4 {\n    margin-top: 20px;\n    margin-bottom: 0px;\n}\n\n.esbRowExpand .escoList .entryList.regular > div {\n    background: white;\n    border-top: 1px solid #f7f7f7;\n}\n\n.esbRowExpand .escoList .entryList.regular > div:first-child {\n    border-top-width: 0px;\n}\n\n.esbRowHead > .label {\n    margin-right: 10px;\n}\n\n.esbRowHead > .float-right.btn {\n    margin-left: 10px;\n}\n\n.esbRowClickExpand > .esbRowHead {\n    cursor: pointer;\n}\n\n\n.entryList .vmiddle.entryControls {\n    vertical-align: top;\n}\n\n.entryList .entryRow .entryControls button {\n    visibility: visible;\n}\n\n/* --- List block, common card classes --- */\n.entryscape .cardList-body {\n    max-width: 400px;\n    box-shadow: 0px 1px 5px #555;\n    background-color: white !important;\n    position: relative;\n    top: 0;\n    transition: all .1s ease-in;\n    margin: 10px;\n    display: inline-block;\n}\n\n.entryscape .cardList-header {\n    display: flex;\n    /* flex-wrap: wrap; */\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n/* Clickable row - cardlist case */\n.entryscape .cardList-body {\n    border: 1px solid #e8e8e8;\n}\n\n.entryscape .cardList-body:hover,\n.entryscape .cardList-body:focus {\n    border: 1px solid darkgrey;\n}\n\n.entryscape .cardList-body.esbRowClickable:hover,\n.entryscape .cardList-body.esbRowClickable:focus {\n    border: 1px solid blue;\n}\n\n.entryscape .cardList-body.esbRowClickable > a {\n    display: inline-block;\n}\n\n/* Clickable row - regular case */\n.entryscape .esbRow.esbRowClickable .esbRowHead {\n    border: 1px solid transparent;\n}\n\n.entryscape .esbRow.esbRowClickable .esbRowHead:hover {\n    background: #f7f7f7;\n    color: #005a9c;\n}\n\n.entryscape .esbRow.esbRowClickable .esbRowHead:focus {\n    border: 1px solid #005a9c;\n    color: #005a9c;\n}\n\n/* End clickable row */\n\n.esb1Col .cardLayout > * > * > .entryList.regular {\n    column-count: 1;\n    column-gap: 10px;\n    max-width: 1200px;\n}\n\n@media (min-width: 620px) {\n    .esb1Col .cardLayout > * > * > .entryList.regular {\n        column-count: 2;\n    }\n}\n\n@media (min-width: 960px) {\n    .esb1Col .cardLayout > * > * > .entryList.regular {\n        column-count: 3;\n    }\n}\n\n.esb2Col .cardLayout > * > * > .entryList.regular {\n    column-count: 1;\n    column-gap: 10px;\n    max-width: 880px;\n}\n\n@media (min-width: 920px) {\n    .esb2Col .cardLayout > * > * > .entryList.regular {\n        column-count: 2;\n    }\n}\n\n@media (min-width: 1260px) {\n    .esb2Col .cardLayout > * > * > .entryList.regular {\n        column-count: 3;\n    }\n}\n\n/*  Specific css, needed? */\n.entryscape .cardList-title {\n    margin: 1em;\n    font-size: 1.5rem;\n    font-style: italic;\n}\n\n.entryscape .cardList-description {\n    margin: 1em;\n    margin-top: 0;\n    padding: .5rem;\n    line-height: 1.6em;\n}\n\n.entryscape .img-container {\n    max-width: 400px;\n}\n\n.entryscape img {\n    width: 100%;\n    max-height: 100%;\n}\n\n.esbRow.esbRowExpanded > .esbRowHead .esbDescription {\n    white-space: pre-line;\n    overflow: visible;\n}\n\n.esbRow > .esbRowHead .esbDescription {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Pagination */\n.entryscape .page-link:not(:disabled) {\n    color: #005a9c;\n}\n\n.entryscape .pagination .page-text {\n    min-width: 2.6em;\n    margin-left: .5em;\n    margin-right: .5em;\n    border-radius: 4em;\n}\n\n/* Override siteVision css for pagination */\n.entryscape .pagination a {\n    margin: 0;\n}\n\n.entryscape .pagination span {\n    margin-bottom: 0;\n}\n\n/* Row alignment */\n.esbRowAlign {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.esbRowAlignPrimary {\n    flex-grow: 1;\n}\n\n.esbRow.esbRowExpanded > .esbRowHead > .esbRowMain > .esbRowAlign > .esbRowEllipsis {\n    white-space: normal;\n    overflow: visible;\n}\n\n.esbRow > .esbRowHead .esbRowAlign > .esbRowEllipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.esbList__hidden {\n    visibility: hidden;\n}\n\n.esbSpinner {\n    visibility: visible;\n    position: absolute;\n    height: 260px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
